
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".727","y":"12.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M20.227 1v34","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"24.727","y":"1.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"24.727","y":"26.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    